import { format } from "date-fns";
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import DateRangePicker from "views/Rfqs/DateRangePicker ";

const FilterLeads = ({ leads, filters, setFilters, handleFilterChange, handleDateRangeChange, companyData, setShowFilters, filteredData }) => {
    const [optionClicked, setOptionClicked] = useState({
        date: false,
        category: false,
        status: false,
        clientName: true,
        companyName: false,
    });
    const [searchTerm, setSearchTerm] = useState("");
    const [dateFilterName, setDateFilterName] = useState("");
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const filteredCompanyData = companyData?.filter((company) =>
        company?.companyName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );


    const handleOptionClicked = (dropdown) => {
        setOptionClicked((prev) => ({
            ...prev,
            [dropdown]: !prev[dropdown],
        }));
    };

    const leadsArray = leads?.leads || [];
    const backendCounts = leads?.counts || {};

    const submittedCount = backendCounts.submitted ?? leadsArray?.filter(
        (lead) => lead?.suppliers[0]?.quotationReceived === true || 0)?.length;
    const pendingCount = backendCounts.pending ?? leadsArray?.filter(
        (lead) => lead?.suppliers[0]?.quotationReceived === false || 0)?.length;
    const allCount = backendCounts.all ?? leadsArray?.length;
    const companyCounts = backendCounts.companies || [];
    const getCompanyCount = (companyName) => {
        const normalizedName = companyName?.toLowerCase?.() || "";
        const matchedCompany = companyCounts.find((company) =>
            company?.companyName?.toLowerCase?.() === normalizedName
        );
        return matchedCompany?.count ?? companyData?.find((company) => company?.companyName === companyName)?.count ?? 0;
    };

    const handleRemoveFilter = (filterKey, value) => {
        setFilters((prev) => {
            let updatedFilters = { ...prev };

            // Logic for handling filter removal
            if (filterKey === "rfqType") {
                updatedFilters.rfqType = updatedFilters.rfqType.filter((item) => item !== value);
                if (updatedFilters.rfqType.length === 0) {
                    updatedFilters.rfqType = ["all"];
                }
            }

            if (filterKey === "companyName") {
                updatedFilters.companyName = updatedFilters.companyName.filter((company) => company !== value);
                if (updatedFilters.companyName.length === 0) {
                    updatedFilters.client = [];
                }
            }

            if (filterKey === "client") {
                updatedFilters.client = updatedFilters.client.filter((client) => client !== value);
            }

            if (filterKey === "dateRange") {
                updatedFilters.startDate = null;
                updatedFilters.endDate = null;
            }

            return updatedFilters;
        });
    };


    return (
        <div>
            {/* Filter Section */}
            <div className="bg-white lg:max-h-[calc(100vh-6rem)] h-full overflow-y-auto lg:min-w-[220px] lg:max-w-[220px] self-start lg:shadow-md lg:border lg:px-4 rounded-md">
                <div className="lg:py-2 border-b lg:bg-white  sticky top-0 z-10">
                    <div className="flex justify-between items-center">
                    <p className="text-sm font-bold text-gray-600">Filters</p>
                    <button onClick={() => setShowFilters(false)} className=" lg:hidden text-md pr-1 opacity-50">
                    ✖
                </button>
                </div>
                    {/* Display selected filters as chips */}
                    {(filters.rfqType?.length > 0 || filters.companyName?.length > 0 || filters.client?.length > 0) && (
                        <div className="flex flex-wrap gap-2 max-h-[200px] overflow-y-auto">
                            {/* Render chips for rfqType */}
                            {filters.rfqType &&
                                filters.rfqType.length > 0 &&
                                (() => {
                                    // Define mapping for the chip labels
                                    const rfqTypeMappings = [
                                        { label: "Material Only", value: "material" },
                                        { label: "Labour Only", value: "labour" },
                                        { label: "Contractor with Material", value: "contractor" },
                                    ];

                                    // Find selected labels based on current filters
                                    const selectedLabels = rfqTypeMappings
                                        .filter(({ value }) => filters.rfqType.includes(value))
                                        .map(({ label }) => label);

                                    return selectedLabels.map((rfq) => (
                                        <div
                                            key={rfq}
                                            className="flex items-center bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs"
                                        >
                                            <span>{rfq}</span>
                                            <button
                                                onClick={() => {
                                                    // Find the corresponding value to remove
                                                    const rfqValueToRemove = rfqTypeMappings.find(
                                                        (mapping) => mapping.label === rfq
                                                    )?.value;

                                                    if (rfqValueToRemove) {
                                                        handleRemoveFilter("rfqType", rfqValueToRemove);
                                                    }
                                                }}
                                                className="ml-2 text-sm font-semibold text-gray-500 hover:text-gray-800"
                                            >
                                                x
                                            </button>
                                        </div>
                                    ));
                                })()}

                            {/* Render chips for companyName */}
                            {filters.companyName && filters.companyName.length > 0 && filters.companyName.map((company) => (
                                <div key={company} className="flex items-center bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs">
                                    <span>{company.charAt(0).toUpperCase() + company.slice(1)}</span>
                                    <button
                                        onClick={() => handleRemoveFilter('companyName', company)}
                                        className="ml-2 text-sm font-semibold text-gray-500 hover:text-gray-800"
                                    >
                                        x
                                    </button>
                                </div>
                            ))}

                            {filters.startDate && filters.endDate && (
                                <div className="flex items-center bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs">
                                    <span>
                                        {`From: ${format(new Date(filters.startDate), "dd-MM-yyyy")} To: ${format(new Date(filters.endDate), "dd-MM-yyyy")}`}
                                    </span>
                                    <button
                                        onClick={() => handleRemoveFilter("dateRange")}
                                        className="ml-2 text-sm font-semibold text-gray-500 hover:text-gray-800"
                                    >
                                        x
                                    </button>
                                </div>
                            )}


                            {/* Render chips for client */}
                            {filters.client && filters.client.length > 0 && filters.client.map((client) => (
                                <div key={client} className="flex items-center bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs">
                                    <span>{client.charAt(0).toUpperCase() + client.slice(1)}</span>
                                    <button
                                        onClick={() => handleRemoveFilter('client', client)}
                                        className="ml-2 text-sm font-semibold text-gray-500 hover:text-gray-800"
                                    >
                                        x
                                    </button>
                                </div>
                            ))}
                        </div>)}
                </div>
                <div className="space-y-3 py-2  text-xs">
                    {/* Quotation Status Filter */}
                    <div>
                        <div
                            onClick={() => handleOptionClicked("status")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold text-gray-500">Status</h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform opacity-50 duration-200 z-0 ease-in-out ${optionClicked.status ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>

                        {!optionClicked.status && (
                            <div className="flex flex-col pt-2 space-y-2 text-gray-600">
                               
                                <span
                                    className={`cursor-pointer text-xs ${filters.quotationReceived === null ? "text-gray-600 font-semibold" : ""
                                        }`}
                                    onClick={() => handleFilterChange("quotationReceived", null)}
                                >
                                    All Leads ({allCount})
                                </span>

                                <span
                                    className={`cursor-pointer text-xs ${filters.quotationReceived === false ? "text-gray-600 font-semibold" : ""
                                        }`}
                                    onClick={() => handleFilterChange("quotationReceived", false)}
                                >
                                    Pending ({pendingCount})
                                </span>

                                <span
                                    className={`cursor-pointer text-xs ${filters.quotationReceived === true ? "text-gray-600 font-semibold" : ""
                                        }`}
                                    onClick={() => handleFilterChange("quotationReceived", true)}
                                >
                                    Submitted ({submittedCount})
                                </span>
                                
                            </div>
                        )}
                    </div>
                    <hr />
                    {/* Date Filters */}
                    {/* <div>
                        <div
                            onClick={() => handleOptionClicked("date")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold  text-gray-500">Date</h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform opacity-50 duration-200 ease-in-out ${optionClicked.date ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        {!optionClicked.date && (
                            <div className="flex flex-col pt-2 gap-2 text-xs text-gray-600">
                                <label className="">
                                    <input
                                        type="radio"
                                        name="date"
                                        value="last7Days"
                                        checked={filters.date === "last7Days"}
                                        onChange={() => handleFilterChange("date", "last7Days")}
                                        className="focus:ring-1 bg-gray-100 border-gray-300"
                                    />
                                    <span className="ml-2 text-xs">Last 7 Days</span>
                                </label>
                                <label className="">
                                    <input
                                        type="radio"
                                        name="date"
                                        value="lastMonth"
                                        checked={filters.date === "lastMonth"}
                                        onChange={() => handleFilterChange("date", "lastMonth")}
                                        className="focus:ring-1 bg-gray-100 border-gray-300"
                                    />
                                    <span className="ml-2 text-xs">Last Month</span>
                                </label>
                                <label className="">
                                    <input
                                        type="radio"
                                        name="date"
                                        value="all"
                                        checked={filters.date === "all"}
                                        onChange={() => handleFilterChange("date", "all")}
                                        className="focus:ring-1 bg-gray-100 border-gray-300"
                                    />
                                    <span className="ml-2 text-xs">All Leads</span>
                                </label>
                            </div>
                        )}
                    </div> */}

                    {/* category filter */}
                    {/* <div className="text-xs">
                        <div
                            onClick={() => handleOptionClicked("category")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold text-gray-500">Category</h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform duration-200 opacity-50 ease-in-out ${optionClicked.category ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        {!optionClicked.category && (
                            <div className="pt-2 space-y-2 text-gray-600">
                                {["Material", "Contractor", "Labour", "All"].map((type) => (
                                    <label key={type} className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            value={type.toLowerCase()}
                                            checked={
                                                filters.rfqType.includes(type.toLowerCase()) ||
                                                filters.rfqType.includes("all")
                                            }
                                            onChange={(e) =>
                                                handleFilterChange("rfqType", e.target.value)
                                            }
                                            className="focus:ring-0 rounded-md bg-gray-100 border-gray-300"
                                        />
                                        <span>{type}</span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div> */}

                    {/* rfqType */}
                    <div className="text-xs">
                        <div
                            onClick={() => handleOptionClicked("category")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold text-gray-500">RFQ Type</h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform duration-200 opacity-50 ease-in-out ${optionClicked.category ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>

                        {!optionClicked.category && (
                            <div className="pt-2 space-y-2 text-gray-600 ">
                                {[
                                    { label: "Material Only", value: "material" },
                                    { label: "Labour Only", value: "labour" },
                                    { label: "Contractor with Material", value: "contractor" },
                                ].map((option) => {
                                    // Check if the current option is selected
                                    const isChecked = filters.rfqType.includes(option.value);

                                    return (
                                        <label key={option.label} className="flex items-center cursor-pointer space-x-2">
                                            <input
                                                type="checkbox"
                                                value={option.value}
                                                checked={isChecked}
                                                onChange={() => {
                                                    setFilters((prevFilters) => {
                                                        let newRfqType = [...prevFilters.rfqType];

                                                        if (isChecked) {
                                                            // Remove the selected value
                                                            newRfqType = newRfqType.filter((v) => v !== option.value);
                                                        } else {
                                                            // Add the selected value
                                                            newRfqType.push(option.value);
                                                        }

                                                        // Ensure "all" is removed when specific filters are selected
                                                        if (newRfqType.includes("all")) {
                                                            newRfqType = newRfqType.filter((v) => v !== "all");
                                                        }

                                                        // If no filters are selected, reset to "all"
                                                        if (newRfqType.length === 0) {
                                                            newRfqType = ["all"];
                                                        }

                                                        return { ...prevFilters, rfqType: newRfqType };
                                                    });
                                                }}
                                                className="focus:ring-0 rounded-md bg-gray-100 border-gray-300"
                                            />
                                            <span>{option.label}</span>
                                        </label>
                                    );
                                })}
                            </div>
                        )}

                    </div>

                    <hr />
                    {/* Client filter */}
                    <div>
                        <div
                            onClick={() => handleOptionClicked("companyName")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold text-gray-500">
                                Company Name
                            </h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform opacity-50 duration-200 ease-in-out ${optionClicked.companyName ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>

                        {/* Search Input */}
                        {!optionClicked?.companyName && (
                            <div className="pt-2">
                                <input
                                    type="text"
                                    placeholder="Search company..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full px-3 py-2 mb-2 text-xs bg-gray-50 border border-gray-300 rounded-md focus:ring-0 focus:ring-blue-400 outline-none"
                                />

                                {/* Filtered Company List */}
                                <div className="space-y-2 text-gray-600">
                                    {filteredCompanyData?.map((company, index) => (
                                        <div key={company?.companyName}>
                                            {/* Company Checkbox */}
                                            <div className="flex space-x-2">
                                                <input
                                                    type="checkbox"
                                                    value={company?.companyName?.toLowerCase()}
                                                    checked={
                                                        filters?.companyName?.includes(
                                                            company?.companyName?.toLowerCase()
                                                        ) || filters?.companyName?.includes("all")
                                                    }
                                                    onChange={(e) =>
                                                        handleFilterChange("companyName", e.target.value)
                                                    }
                                                    className="focus:ring-0 rounded-md bg-gray-100 border-gray-300"
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <span>{company?.companyName} ({getCompanyCount(company?.companyName)})</span>
                                            </div>

                                            {/* Only show clients if the company is selected */}
                                            {filters?.companyName?.includes(
                                                company?.companyName?.toLowerCase()
                                            ) && (
                                                    <div className="pl-6 pt-1 space-y-2">
                                                        {company?.clients.map((client) => (
                                                            <div
                                                                key={client}
                                                                className="flex items-center space-x-2"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    value={client?.toLowerCase()}
                                                                    checked={
                                                                        filters.client?.includes(
                                                                            client?.toLowerCase()
                                                                        ) || filters.client?.includes("all")
                                                                    }
                                                                    onChange={(e) =>
                                                                        handleFilterChange("client", e.target.value)
                                                                    }
                                                                    className="focus:ring-0 rounded-md bg-gray-100 border-gray-300"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />
                                                                <span>{client}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <hr />
                    {/* date range filter */}
                    <div className="hidden lg:block">
                        <div
                            onClick={() => handleOptionClicked("dateRange")}
                            className="cursor-pointer flex justify-between items-center space-x-2"
                        >
                            <h3 className="text-sm font-semibold text-gray-500">Date Range</h3>
                            <svg
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-5 h-5 transition-transform opacity-50 duration-200 z-0 ease-in-out ${optionClicked.dateRange ? "transform rotate-180" : ""
                                    }`}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        {!optionClicked.dateRange && (
                            <div>
                                <div className="mt-2">
                                    {/* <p className="font-bold mb-1 text-xs"></p> */}
                                    <DateRangePicker
                                        title="Select Date Range"
                                        style={"bg-gray-200 text-black"}
                                        handleApplyFilterDate={handleDateRangeChange}
                                        startDate={filters.startDate}
                                        endDate={filters.endDate}
                                        setDateFilterName={setDateFilterName}
                                    />
                                </div>
                                {/* <div className="mt-2">
                                    <p className="font-bold text-xs mb-1">Close Date</p>
                                    <DateRangePicker
                                        title="Select Date Range"
                                        style={"bg-gray-200 text-black"}
                                        handleApplyFilterDate={handleDateRangeChange}
                                        startDate={filters.startDate}
                                        endDate={filters.endDate}
                                        setDateFilterName={setDateFilterName}
                                    />
                                </div> */}
                            </div>
                        )}
                    </div>

                    {/* <div>
              <div
                onClick={() => handleOptionClicked("dateRange")}
                className="cursor-pointer flex justify-between items-center space-x-2"
              >
                <h3 className="text-sm font-semibold text-gray-500">Date Range</h3>
                <svg
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`w-5 h-5 transition-transform opacity-50 duration-200 ease-in-out ${
                    optionClicked.dateRange ? "transform rotate-180" : ""
                  }`}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
              {!optionClicked.dateRange && (
                 <div className="pl-3">
                 <div className="mt-2">
                   <p className="font-bold mb-1 text-xs">Create Date</p>
                   <DateRangePicker
                     style={"bg-gray-200 text-black"}
                     title="Create Date"
                    //  setDateFilterName={setDateFilterName}
                    //  handleApplyFilterDate={handleDateChange}
                    //  startDate={rfqsData?.startDate}
                    //  endDate={rfqsData?.endDate}
                   />=
                 </div>
                 <div className="mt-2">
                   <p className="font-bold text-xs mb-1">Close Date</p>
                   <DateRangePicker
                     style={"bg-gray-200 text-black"}
                     title="Close Date"
                    //  setDateFilterName={setCloseDateFilterName}
                    //  handleApplyFilterDate={handleCloseDateChange}
                    //  startDate={rfqsData?.startDateOfClosing}
                    //  endDate={rfqsData?.endDateOfClosing}
                   />
                 </div>
               </div>
              )}
            </div> */}

                    {/* <h3 className="text-sm px-4 text-gray-">Status</h3>
                                                    <div className="flex flex-col text-sm">
                                                        <label className="px-4 py-1 hover:bg-gray-200">
                                                            <input
                                                                type="radio"
                                                                name="status"
                                                                value="CLOSED"
                                                                checked={filters.quotationReceived === "CLOSED"}
                                                                onChange={() => handleFilterChange("status", "CLOSED")}
                                                            />
                                                            <span className="ml-2">Closed</span>
                                                        </label>
                                                        <label className="px-4 py-1 hover:bg-gray-200">
                                                            <input
                                                                type="radio"
                                                                name="status"
                                                                value="HOLD"
                                                                checked={filters.status === "HOLD"}
                                                                onChange={() => handleFilterChange("status", "HOLD")}
                                                            />
                                                            <span className="ml-2">Hold</span>
                                                        </label>
                                                        <label className="px-4 py-1 mb-2 hover:bg-gray-200">
                                                            <input
                                                                type="radio"
                                                                name="status"
                                                                value="all"
                                                                checked={filters.status === "all"}
                                                                onChange={() => handleFilterChange("status", "all")}
                                                            />
                                                            <span className="ml-2">All</span>
                                                        </label>
                                                    </div> */}
                    {/* Quotation Status Filter */}
                </div>
            </div>
        </div>
    );
};

export default FilterLeads;

